import { defineMessage } from 'react-intl';

export const gipReportDateRangeExceededMessage = defineMessage({
  id: 'audit.gipReport.error.dateRangeExceeded',
  defaultMessage: 'El rango de fechas no puede superar los {maxDays} días.',
});

export const gipReportFromMustBeBeforeToMessage = defineMessage({
  id: 'audit.gipReport.error.fromMustBeBeforeTo',
  defaultMessage: 'La fecha de inicio debe ser anterior a la fecha de fin.',
});
